import {restoreServiceFunction} from "@project/sdk/engineering";
import {mutationOptions} from "@tanstack/react-query";

import {serviceFunctionKeys, serviceFunctionMutationKeys} from "../../../serviceFunction-keys";

export function restoreServiceFunctionMutationOptions() {
  return mutationOptions({
    mutationFn: (serviceFunctionId: string) => restoreServiceFunction(serviceFunctionId),
    mutationKey: serviceFunctionMutationKeys.restoreServiceFunction,
    onSuccess: async (_data, serviceFunctionId, _context, {client}) => {
      client.removeQueries({queryKey: serviceFunctionKeys.detail(serviceFunctionId)});
      await client.invalidateQueries({queryKey: serviceFunctionKeys.lists()});
    },
  });
}
